module.exports = __webpack_public_path__ + "img/losplatoslogo.b7150e97.png";